(function () {

  /**
   * Initialize Swiper on product cards
   * @param {HTMLElement|Document} scope
   */
  function initProductCardSwipers(scope = document) {

    if (typeof Swiper === 'undefined') return;

    const containers = scope.querySelectorAll('.product-card-swiper');

    containers.forEach(container => {

      if (container.classList.contains('swiper-initialized')) return;

      new Swiper(container, {
        slidesPerView: 1,
        loop: true,
        nested: true,
        threshold: 5,
        watchOverflow: true,
        navigation: {
          nextEl: container.querySelector('.swiper-button-next'),
          prevEl: container.querySelector('.swiper-button-prev'),
        },

        on: {
          init(swiper) {
            swiper.update();
          }
        }
      });
    });
  }

  function observeDynamicContent() {

    const targets = [
      document.querySelector('product-recommendations'),
      document.querySelector('[data-section-type="related-products"]')
    ].filter(Boolean);

    targets.forEach(target => {

      const observer = new MutationObserver(() => {
        initProductCardSwipers(target);
      });

      observer.observe(target, {
        childList: true,
        subtree: true
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initProductCardSwipers();
    observeDynamicContent();
  });
  document.addEventListener('shopify:section:load', (event) => {
    initProductCardSwipers(event.target);
  });

})();
